import { Environment } from './environment.interface';

/**
 * Default development environment configuration
 * Used when running `ng serve` or `npm start`
 */
export const environment: Environment = {
  name: 'ps',
  production: false,

  api: {
    baseUrl: 'https://ps.apps.manulife.co.jp/ext/ps/eclaims/api/v1/'
  },
  session: {
    timeoutMinutes: 60,       // ✅ 15 minutes for production
    warningMinutes: 2         // ✅ 2 minutes warning for production
  },

  app: {
    version: '1.0.0-dev',
    name: 'JPES eClaims',
    defaultLanguage: 'ja',
    supportedLanguages: ['ja', 'en'],
    appUrl: 'https://ps.e-seikyu.manulife.co.jp/#/eclaim',
    newRelicUrl: '/assets/newRelic/JPES-ECLAIMS-UAT.js',
    adobeAnalyticsUrl: 'https://assets.adobedtm.com/b84dbf01908c/ea9ea5ad8be8/launch-b7a8bf727ff2-staging.min.js'
  }
};